import React from 'react';
import '../styles/Styles.scss';

class Footer extends React.Component {
  render() {
    const twitter = require('../images/Twitter.svg');
    const discord = require('../images/Discord.svg');
    return (
      <div className={'blueBgColor'}>
        <div className={'container noPadd'}>
          <div className={'footerWrapper'}>
            <div className={'pageDescription'}>
              Built with <i className="fas fa-heart"></i> by <a href={'http://hasura.io/'} target={'_blank'}>Hasura</a>
            </div>
            <div className={'socialWrapper'}>
              <div className={'socialIcon'}>
                <a href={'https://twitter.com/hasurahq'} target={'_blank'}><img className={'img-responsive'} src={twitter} alt={'twitter'} /></a>
              </div>
              <div className={'socialIcon'}>
                <a href={'https://discord.gg/vBPpJkS'} target={'_blank'}><img className={'img-responsive'} src={discord} alt={'discord'} /></a>
              </div>
            </div>
            <div className={'pageDescriptionSmall'}>
              © 2018 Hasura Inc. All rights reserved
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Footer;
